import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./en-US.json";
import fr from "./fr-FR.json";
import es from "./es-ES.json"
import Backend from 'i18next-http-backend';

const resources = {
  en,
  fr,
  es
}

export const availableLanguages = Object.keys(resources)

i18n.use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend) 
  .init({
    resources,
    defaultNS: "common",
    fallbackLng: "en" // default language
  });